package uz.ferro.shop.model

enum class ProductGroupUIType {
    HORIZONTAL,
    VERTICAL_GRID;

    companion object {
        fun from(value: String): ProductGroupUIType {
            return entries.firstOrNull { it.name == value} ?: HORIZONTAL
        }
    }
}